import { motion } from 'framer-motion';
import styles from './Hero.module.css';

export default function Hero() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 16 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' }
    }
  };

  return (
    <section className={styles.hero} id="hero">
      <motion.div
        className={styles.container}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1 variants={itemVariants} className={styles.headline}>
          Infrastructure is the competitive advantage.
        </motion.h1>
        <motion.p variants={itemVariants} className={styles.subheadline}>
          Infundra is an infrastructure-led venture platform deploying a single, production-grade stack across a focused portfolio of AI-native B2B companies.
        </motion.p>
        <motion.p variants={itemVariants} className={styles.supporting}>
          One compliance posture. One integrated stack.<br />
          Compounding returns across every product built on it.
        </motion.p>
      </motion.div>
    </section>
  );
}
